import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import FacebookIcon from "../../assets/monqez-assets/facebook_icon.png";

import InstaIcon from "../../assets/monqez-assets/instagram_icon.png";
import telegramIcon from "../../assets/monqez-assets/telegram_icon.png";
import tiktokIcon from "../../assets/monqez-assets/tiktok_icon.png";
import youtubeIcon from "../../assets/monqez-assets/youtube_2504965.png";

import FooterLink from "./components/FooterLink";
import { Facebook, Youtube, Tiktok, instagram } from "./Icons";
import { useLocation } from "react-router-dom";
import { adminPath, teachersubadminPath } from "../../services/defaultSettings";
import CenterIcon from "../../components/ui/CenterIcon";
import Logo from "../../assets/telawah-assets/2 (3).png";
import { useLanguage } from "../../context/LanguageContext";
const Footer = () => {
    const { language } = useLanguage();
    const location = useLocation();

    const [className, setClassName] = useState("");
    const footerContent = {
        description: {
            en: "A dedicated platform for learning the Quran and Islamic teachings.",
            ar: "منصة متخصصة لتعليم القرآن الكريم وتعاليم الإسلام.",
        },
    };
    useEffect(() => {
        if (
            location.pathname.includes(adminPath) ||
            location.pathname.includes(teachersubadminPath)
        ) {
            setClassName(" !hidden");
        } else {
            setClassName("");
        }
    }, [location.pathname]);
    return (
        <div
            className={`${
                language === "en" ? "en" : "ar"
            } footer bg-ashGray-800 overflow-hidden relative py-20 clr-white flex-center-both flex-col space-y-6 w-full ${className} gap-6`}
        >
            <div className="h-auto flex justify-center">
                <img src={Logo} alt="Logo" className="w-[130px] md:w-[200px]" />
            </div>
            <div className="flex-center-both space-x-2 space-x-reverse z-10 text-2xl smooth rounded-md px-5 saturate-50">
                <p className="">{footerContent.description[language]}</p>{" "}
            </div>
            <div className="relative w-screen">
                <div
                    className={`relative z-10 flex items-center justify-center space-x-5 ${
                        language === "en" ? "" : " space-x-reverse"
                    }  gap-2`}
                >
                    <FooterLink
                        link="#"
                        scale={false}
                        icon={<img src={FacebookIcon} alt="facebook" className="w-12 h-auto" />}
                    />
                    <FooterLink
                        link="#"
                        scale={false}
                        icon={<img src={telegramIcon} alt="tiktok" className="w-12 h-auto" />}
                    />
                    <FooterLink
                        link="#"
                        scale={false}
                        icon={<img src={tiktokIcon} alt="tiktok" className="w-12 h-auto" />}
                    />
                    <FooterLink
                        link="#"
                        scale={false}
                        icon={<img src={InstaIcon} alt="InstaIcon" className="w-12 h-auto" />}
                    />
                    <FooterLink
                        link="#"
                        scale={false}
                        icon={<img src={youtubeIcon} alt="youtubeIcon" className="w-12 h-auto" />}
                    />
                </div>
            </div>
            {/* <div className="h-1 bg-slate-800 rounded-md w-2/3 sm:w-1/3 "></div> */}
            <div className="Footer__wrapper-button mt-9 lg:mt-0">
                <div className="en textx text-center font-com space-x-2 opacity-90 px-5 flex flex-wrap flex-center-both">
                    <span className="font-w-bold space-x-1">
                        <span className="text-ashGray-200">&#60;</span>
                        <span className="text-ashGray-400">Developed By</span>
                        <span className="text-ashGray-200">&#62;</span>
                    </span>
                    <span>
                        <a
                            href="https://www.facebook.com/Om4rS4Ieh/"
                            className="text-earthYellow-300 font-w-bold  hover-shadow smooth px-2 py-2 rounded-md"
                        >
                            Omar
                        </a>
                        <span>,</span>
                        <a
                            href="https://www.facebook.com/emad.sharf.16"
                            className="text-earthYellow-300 font-bold hover-shadow smooth px-3 py-1 rounded-md"
                        >
                            Emad
                        </a>
                    </span>
                    <span className="font-w-bold space-x-1">
                        <span className="text-ashGray-200">&#60;</span>
                        <span className="text-ashGray-400">
                            All Copy Rights Reserved @{new Date().getFullYear()}
                        </span>
                        <span className="text-ashGray-200">&#62;</span>
                    </span>
                </div>
            </div>
            {/* <div className="text"></div> */}
        </div>
    );
};

export default Footer;
